function handleRegistration() {
  if (!location.pathname.startsWith('/i/')) {
    return;
  }
  navigator.serviceWorker.register(`worker.bundle.js?base=${encodeURIComponent(window.env.ASSET_ROOT)}`, {scope: '/i/'})
    .catch(err => {
      /* eslint-disable no-console */
      console.error(new Error('Problem registering service worker'));
      console.error(err);
      /* eslint-enable no-console */
    });
}

export function register() {
  if ('serviceWorker' in navigator) {
    handleRegistration();
  }
}
